module.exports = __webpack_public_path__ + "img/logo-bestiario.2172bd1c.svg";